import { Action } from '@ngrx/store';
import { label } from '../util';

export const FeatureFlagsActionTypes = {
	SET_FEATURE_FLAGS: label('[FEATURE_FLAGS] Set Feature Flags')
};

export class SetFeatureFlagsAction implements Action {
	readonly type = FeatureFlagsActionTypes.SET_FEATURE_FLAGS;
	constructor(public payload: any) {}
}
